import React from 'react';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';

export const columns: ColumnInterface[] = [
  {
    title: 'Код отчета',
    key: 'code',
    width: 120,
    fixedLeft: true,
  },
  {
    title: 'Внешний код отчета',
    key: 'code_ext',
    width: 150,
  },
  {
    title: 'Наименование отчета',
    key: 'name',
    width: 400,
  },
  {
    title: 'Описание',
    key: 'description',
    width: 300,
  },
  {
    title: 'Регламентированный отчет',
    key: 'regulated',
    render: ({ value }) => value && <Icon name="check" />,
    width: 220,
  },
  {
    key: 'report_group_code',
    hidden: true,
  },
  {
    key: 'report_type_code',
    hidden: true,
  },
];
